<template>
    <div>
        <button
            type="button"
            class="btn btn-md is-primary"
            @click="$modal.show(modalName)"
        >
            Ladda upp fil
        </button>
        <adaptive-form-modal
            :name="modalName"
            primary-button-text="Ladda upp"
            primary-button-class="is-primary"
            title="Filuppladdning"
            :redirect-to="redirectRoute"
            :action="route('api.internal-external-files.store')"
        >
            <input
                type="hidden"
                name="file_archive_model_id"
                :value="fileArchiveModelId"
            >

            <input
                type="hidden"
                name="file_archive_model_type"
                :value="fileArchiveModelType"
            >

            <h2 class="headline-sm font-semibold mb-md">Välj fil</h2>

            <input
                id="file"
                type="file"
                name="file"
                class="hidden"
                @change="setFile"
            >
            <label class="btn btn-md is-primary cursor-pointer" for="file">
                Välj fil
            </label>

            <span class="ml-md text-sm">
                <span v-if="file">
                    Fil har valts
                </span>
                <span v-else>
                    Ingen fil har valts
                </span>
            </span>

            <div class="text-xs mt-md">
                <span>
                    Största tillåtna filstorleken är {{ maxFileSize }}
                </span>
            </div>

            <h2 class="headline-sm font-semibold mt-2xl my-md">Namnsätt (frivilligt)</h2>

            <text-input
                v-model="name"
                :value="name"
                name="name"
                label="Namn"
            />

            <div v-show="canManageInternalFiles">
                <h2 class="headline-sm font-semibold mt-2xl mb-md">Synlighet</h2>

                <div class="flex items-center bg-neutral-lightest p-md text-sm mb-xl">
                    <font-awesome-icon icon="info-circle" class="text-lg mr-md" />
                    <span>
                        Filer som delas internt delas enbart inom organisationen. Filer som delas externt syns även för
                        externa parter som underentreprenörer och fälttekninker.
                    </span>
                </div>

                <div class="mb-sm">
                    <radio-input
                        v-model="selectedVisibility"
                        name="visibility"
                        value="internal"
                        :required="true"
                    >
                        Internt
                    </radio-input>
                </div>

                <radio-input
                    v-model="selectedVisibility"
                    name="visibility"
                    value="external"
                    :required="true"
                >
                    Externt
                </radio-input>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            fileArchiveModelId: {
                type: Number,
                default: null,
            },
            fileArchiveModelType: {
                type: String,
                default: null,
            },
            redirectRoute: {
                type: String,
                default: '',
            },
            canManageInternalFiles: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                selectedVisibility: 'external',
                name: '',
                file: null,
            };
        },

        computed: {
            modalName() {
                return `upload-internal-external-file-${this.fileArchiveModelType}-${this.fileArchiveModelId}`;
            },
            maxFileSize() {
                return (window.App && window.App.maxFileSizeMedia) ? window.App.maxFileSizeMedia : '-';
            },
        },

        methods: {
            setFile(event) {
                this.file = event.target.value;
            },
        },
    };
</script>
